import { FC } from 'react'
import Box from '@mui/material/Box'
import { templates } from '../../../../constants/templates'
import config from '../../../../config'
import { imageDimensions } from '../../../../constants/imageDimensions'
import TemplateTile from './TemplateTile'

const CreateTemplatePanel: FC<{
  lastChangedTemplateUrl?: string | null
  onTemplateSelected: (args?: { defaultTemplateJSON: any }) => void
}> = ({ lastChangedTemplateUrl, onTemplateSelected }) => {
  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'row',
        flex: 1,
        position: 'relative',
        overflow: 'hidden',
      }}
    >
      <Box
        component={'ul'}
        sx={{
          backgroundColor: 'pageBackground',
          display: 'grid',
          gridTemplateColumns: {
            xs: 'repeat(2, 1fr)',
            md: 'repeat(4, 1fr)',
          },
          gap: 2,
          padding: 2,
          margin: 0,
          width: '100%',
        }}
      >
        {lastChangedTemplateUrl ? (
          <TemplateTile
            id={`template-edit-current`}
            url={lastChangedTemplateUrl}
            name={'Edit current template'}
            onTemplateSelected={onTemplateSelected}
          />
        ) : (
          <>
            <TemplateTile
              id={`template-option-blank`}
              name={'Blank template'}
              template={null}
              onTemplateSelected={onTemplateSelected}
            />
            {templates.map(({ fileName, name, template }) => {
              const url = `${config.imgixBaseUrl}previews/core/${fileName}?page=1&fm=png&auto=format&fit=max&w=${imageDimensions.width}&h=${imageDimensions.height}`
              return (
                <TemplateTile
                  key={fileName}
                  id={`template-option-${fileName}`}
                  url={url}
                  name={name}
                  template={template}
                  onTemplateSelected={onTemplateSelected}
                />
              )
            })}
          </>
        )}
      </Box>
    </Box>
  )
}

export default CreateTemplatePanel
